import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showToast } from '@/services/toast-service';
import { updateBroadcastMessage } from '@/services/coloc-api/admin';

type UpdateBroadcastMessageVariables = {
  id: number;
  data: FormData;
};

export const useUpdateBroadcastMessage = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: ['updateBroadcastMessage'],
    mutationFn: ({ id, data }: UpdateBroadcastMessageVariables) => updateBroadcastMessage(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries(['broadcast-messages']);
    },
    onError: () => {
      showToast.error({
        title: 'Failed to update broadcast message',
        text: 'Please try again.',
      });
    },
  });

  return {
    updateMessage: mutation.mutate,
    isLoading: mutation.isLoading,
    error: mutation.error,
  };
};
